// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__PoQL9","divider":"Welcome_divider__6RsID","videoInstructions":"Welcome_videoInstructions__muO5b"};